var t,l;!function(t){t[t.RowClick=0]="RowClick",t[t.ButtonClick=1]="ButtonClick"}(t||(t={})),function(t){t[t.SingleSelect=0]="SingleSelect",t[t.MultiSelect=1]="MultiSelect"}(l||(l={}));export{t as S,l as a};
//# sourceMappingURL=select-d972db04.js.map
